export default "//static.tradera.net/touchweb/static/output/images/qr-code-appstore.722775fa.svg";